module.exports = __webpack_public_path__ + "img/homepage_5.8af66e52.svg";